import React from 'react';
import { Button, TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Slider from '../../../slider/Slider';
import { AppConfigs, AppSkinProps } from '../../../../types/decisions';

const UpTo6Fields = ({
    zipCodes,
    onZipChange,
    displaySingleField = false,
}: {
    zipCodes: string[];
    onZipChange: (newZipCode: string, idx: number) => void;
    displaySingleField?: boolean
}) => {
    if (displaySingleField) {
        return (
            <div>
                <TextField
                    type="text"
                    style={{ marginRight: 4 }}
                    defaultValue={zipCodes[0]}
                    onBlur={e => onZipChange(e.target.value, 0)}
                />
            </div>
        );
    }

    return (
        <>
            {zipCodes.map((zipCode, index) => (
                <div key={`zipcode-${index}`} style={{ marginBottom: 4 }}>
                    <TextField
                        type="text"
                        defaultValue={zipCode}
                        onBlur={e => onZipChange(e.target.value, index)}
                    />
                </div>
            ))}
        </>
    );
};

const AppCriteriaTypeZip = ({
    importance,
    hideValues,
    hideImportance,
    onSliderChange,
    onTradeoffValueChange,
    value = [ '', '', '', '', '', '' ],
    showAddConstraint,
    variant,
    id,
}: {
    importance: number;
    hideValues?: boolean;
    hideImportance?: boolean;
    showAddConstraint?: boolean;
    onSliderChange: AppSkinProps['onSliderChange'];
    onTradeoffValueChange: (value: any, id: string, key: string) => void;
    value: string[];
    variant: AppConfigs['criteriaSettings']['zipcode'];
    id: string;
}) => {
    const onZipChange = (newZipCode: string, index: number) => {
        onTradeoffValueChange(
            newZipCode,
            id,
            index + '',
        );
    };

    const zipComponents = {
        Map: <UpTo6Fields zipCodes={value} onZipChange={onZipChange}/>,
        Agent: <UpTo6Fields zipCodes={value} onZipChange={onZipChange}/>,
        SingleField: <UpTo6Fields zipCodes={value} onZipChange={onZipChange} displaySingleField/>,
        Upto6Fields: <UpTo6Fields zipCodes={value} onZipChange={onZipChange}/>,
    };

    return (
        <div>
            {hideValues ? null : (
                <div style={{ marginBottom: 10 }}>
                    {zipComponents[variant]}
                </div>
            )}
            {hideImportance ? null : (
                <div>
                    <Slider
                        min={0}
                        max={100}
                        step={1}
                        defaultValue={importance}
                        leftText="Not Important"
                        rightText="Really Important"
                        onChangeCommitted={(_, value) => onSliderChange(value as number, id)}
                    />
                </div>
            )}
            {!showAddConstraint ? null : (
                <div style={{ marginTop: 20 }}>
                    <Button
                        variant="outlined"
                        startIcon={<AddIcon/>}
                        size="small"
                    >
                        Add Constraint
                    </Button>
                </div>
            )}
        </div>
    );
};

export default AppCriteriaTypeZip;
